import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getPaketKuesioner = 'kusioner';
const getPaketAllKuesioner = 'kusioner';
const getDetailPaketKuesioner = 'kusioner/';
const postKuesionerUrl = 'kusioner';
const putKuesioner = 'kusioner/';
const deleteKuesioner = 'kusioner/';


class PaketKuesionerService {
    getPaketKuesioner(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getPaketKuesioner + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter, {
                headers: authHeader()
            });
    }

    getPaketAllKuesioner() {
        return axios.get(
            API_URL + getPaketAllKuesioner , {
                headers: authHeader()
            });
    }

    getDetailPaketKuesioner(idKuesioner) {
        return axios.get(
            API_URL + getDetailPaketKuesioner + idKuesioner, {
                headers: authHeader()
            });
    }

    postKuesioner(formData) {
        return axios
            .post(
                API_URL + postKuesionerUrl,
                formData, {
                    headers: authHeader()
                }
            );
    }

    putKuesioner(formData, idKuesioner) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putKuesioner + idKuesioner, formData, {
                    headers: authHeader()
                }
            );
    }

    deleteKuesioner(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteKuesioner + formData.idKuesioner, {
                    headers: authHeader()
                }
            );
    }

}

export default new PaketKuesionerService();